import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=0cf4bad0&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=0cf4bad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4bad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf4bad0')) {
      api.createRecord('0cf4bad0', component.options)
    } else {
      api.reload('0cf4bad0', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=0cf4bad0&scoped=true&", function () {
      api.rerender('0cf4bad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Profile.vue"
export default component.exports